var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadialBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1468,
    height: 1468,
    viewBox: "0 0 1468 1468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1466 734C1466 1138.27 1138.27 1466 734 1466C329.727 1466 2 1138.27 2 734C2 329.727 329.727 2 734 2C1138.27 2 1466 329.727 1466 734ZM1468 734C1468 1139.38 1139.38 1468 734 1468C328.623 1468 0 1139.38 0 734C0 328.623 328.623 0 734 0C1139.38 0 1468 328.623 1468 734ZM1291.54 734C1291.54 1041.92 1041.92 1291.54 733.999 1291.54C426.08 1291.54 176.462 1041.92 176.462 734C176.462 426.08 426.08 176.462 733.999 176.462C1041.92 176.462 1291.54 426.08 1291.54 734ZM1293.54 734C1293.54 1043.02 1043.02 1293.54 733.999 1293.54C424.975 1293.54 174.462 1043.02 174.462 734C174.462 424.976 424.975 174.462 733.999 174.462C1043.02 174.462 1293.54 424.976 1293.54 734ZM734 1148.51C962.927 1148.51 1148.51 962.927 1148.51 734C1148.51 505.073 962.927 319.491 734 319.491C505.073 319.491 319.491 505.073 319.491 734C319.491 962.927 505.073 1148.51 734 1148.51ZM734 1150.51C964.032 1150.51 1150.51 964.032 1150.51 734C1150.51 503.968 964.032 317.491 734 317.491C503.968 317.491 317.491 503.968 317.491 734C317.491 964.032 503.968 1150.51 734 1150.51ZM1018.06 734C1018.06 890.88 890.879 1018.06 734 1018.06C577.12 1018.06 449.944 890.88 449.944 734C449.944 577.121 577.12 449.945 734 449.945C890.879 449.945 1018.06 577.121 1018.06 734ZM1020.06 734C1020.06 891.984 891.984 1020.06 734 1020.06C576.016 1020.06 447.944 891.984 447.944 734C447.944 576.016 576.016 447.945 734 447.945C891.984 447.945 1020.06 576.016 1020.06 734Z",
    fill: "url(#paint0_radial_1753_1323)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1753_1323",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(734 734) rotate(90) scale(734 808.308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadialBg);
export default __webpack_public_path__ + "static/media/RadialBg.e20fd359c43ad4097be2dcef654ca45f.svg";
export { ForwardRef as ReactComponent };